import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async (n = 0) => {
      if (cancelled || n >= 10) { if (!cancelled) setStatus("timeout"); return; }
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        setAttempts(n + 1);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => poll(n + 1), 2000);
      } catch {
        setTimeout(() => poll(n + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="kz-container py-20">
      <div className="max-w-lg mx-auto kz-card p-10 text-center">
        {status === "checking" && (
          <>
            <Loader2 size={56} className="mx-auto text-brand animate-spin mb-4"/>
            <h1 className="font-display text-2xl font-black mb-2">Ödeme Doğrulanıyor</h1>
            <p className="text-ink-500 text-sm">Lütfen bekleyin... ({attempts}/10)</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-green-600 mb-4"/>
            <h1 className="font-display text-3xl font-black mb-2">Ödeme Başarılı!</h1>
            <p className="text-ink-500 mb-6">Siparişiniz alındı. En kısa sürede kargoya verilecektir.</p>
            <Link data-testid="success-account-btn" to="/hesabim" className="kz-btn-primary">Siparişlerim</Link>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <XCircle size={56} className="mx-auto text-destructive mb-4"/>
            <h1 className="font-display text-2xl font-black mb-2">Bir Sorun Oluştu</h1>
            <p className="text-ink-500 mb-6">Ödeme tamamlanamadı veya doğrulama zaman aşımına uğradı.</p>
            <Link to="/sepet" className="kz-btn-dark">Sepete Dön</Link>
          </>
        )}
      </div>
    </div>
  );
}
